const BYTES_IN_KILOBYTE = 1000;
const BYTES_IN_MEGABYTE = BYTES_IN_KILOBYTE * BYTES_IN_KILOBYTE;

// if the size of an element will be less that 10 kilobytes it will return 0MB string as output.
// that's why we need to introduce this threshold - switch between kilobytes and megabytes
const OUTPUT_THRESHOLD = 10 * BYTES_IN_KILOBYTE;

const round = number => Math.round(number * 100) / 100;

export const bytesToString = (bytes) => {
  const outputInKilobytes = bytes < OUTPUT_THRESHOLD;

  const divider = outputInKilobytes ? BYTES_IN_KILOBYTE : BYTES_IN_MEGABYTE;

  const bytesValue = round(bytes / divider);

  return `${bytesValue}${outputInKilobytes ? 'KB' : 'MB'}`;
};



// WEBPACK FOOTER //
// ./src/components/attachments/list/item/helpers.js